import * as typedrequestInterfaces from '@api.global/typedrequest-interfaces';
import type * as browserRuntime from '@modelprofile.com/browser-runtime';
import type * as authswitch from '@modelprofile.com/authswitch';
// The account-management contract on its own. Its own doc comment declares it credential-free and
// safe for browser code, while the package root is Node-only, so the browser-facing interfaces take
// the subpath rather than the root export.
import type * as authswitchAuthority from '@modelprofile.com/authswitch/authority-contract';
// The one-time import's report contract, on its own subpath for the same reason: its inventory is
// documented as management-only and credential-free, and a type import adds no module to the bundle.
import type * as authswitchImport from '@modelprofile.com/authswitch/authority-import-contract';
import type {
  AuthenticationResponseJSON,
  PublicKeyCredentialCreationOptionsJSON,
  PublicKeyCredentialRequestOptionsJSON,
  RegistrationResponseJSON,
} from '@simplewebauthn/server';

export { typedrequestInterfaces };
export type { browserRuntime };
export type { authswitch };
export type { authswitchAuthority };
export type { authswitchImport };
export type {
  AuthenticationResponseJSON,
  PublicKeyCredentialCreationOptionsJSON,
  PublicKeyCredentialRequestOptionsJSON,
  RegistrationResponseJSON,
};
